/**
 * Alerts
 */
const $ = window.jQuery;
const php = window.php;
const startMaintenanceWindow = php.startMaintenanceWindow;
const endMaintenanceWindow = php.endMaintenanceWindow;

export class Alerts {
  constructor() {
    this.scheduledBankingMaintenance();
  }

  scheduledBankingMaintenance() {
    $.post(`/api/alerts/`, (data) => {
      // Testing: ?test-date=02-19-2023
      const urlParams = new URL(window.location).searchParams;
      const testDate = urlParams.get("test-date");
      const today = testDate ? new Date(testDate) : new Date();
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const currentMonth = months[today.getMonth()];
      const dayOfMonth = today.getDate();
      const currentYear = today.getFullYear();
      const inMaintenanceWindow = today.getHours() >= 0 && today.getHours() < 6;
      const secondSunday = data.second_sunday;
      const thirdSunday = data.third_sunday;
      const isThirdSunday = today.getDate() === thirdSunday;
      const beforeThirdSunday = today.getDate() < thirdSunday;
      const afterSecondSunday = today.getDate() >= secondSunday;

      if (isThirdSunday && inMaintenanceWindow) {
        console.log(`It's the 3rd Sunday of the month.`);
        //this.activeBankingMaintenance(currentMonth, thirdSunday, currentYear);
      }

      if (afterSecondSunday && beforeThirdSunday) {
        console.log(`It's between the 2nd and 3rd Sunday of the month.`);
        //this.passiveBankingMaintenance(currentMonth, thirdSunday, currentYear);
      }
    });
  }

  activeBankingMaintenance(currentMonth, thirdSunday, currentYear) {
    const $existingAlert = $(".alert-bar");

    if ($existingAlert.length) {
      $existingAlert.remove();
    }
    const $message = $(`
    <div class="alert-bar alert-bar-danger">
      <p><strong>Member Service</strong></p>
      <p>Online banking and bill pay will be unavailable from ${startMaintenanceWindow} to ${endMaintenanceWindow} on Sunday, ${currentMonth} ${thirdSunday}, ${currentYear}, while we perform maintenance on our systems. Our ATMs and 24-Hour Teller Phone will also be offline for this period. ATM/debit cards will work during this time, but only to lower card limits. We apologize for any inconvenience this may cause.</p>
    </div>
    `);
    $("body").prepend($message);
  }

  passiveBankingMaintenance(currentMonth, thirdSunday, currentYear) {
    const $existingAlert = $(".alert-bar");

    let existingMessage = "";
    if ($existingAlert.length) {
      existingMessage += $existingAlert.html() + "<hr>";
      $existingAlert.remove();
    }
    const $message = $(`
    <div class="alert-bar alert-bar-original">
      ${existingMessage}
      <p><strong>Member Service</strong> Online banking and bill pay will be unavailable from ${startMaintenanceWindow} to ${endMaintenanceWindow} on Sunday, ${currentMonth} ${thirdSunday}, ${currentYear}, while we perform maintenance on our systems. Our ATMs and 24-Hour Teller Phone will also be offline for this period. ATM/debit cards will work during this time, but only to lower card limits. We apologize for any inconvenience this may cause.</p>
    </div>
    `);
    $("body").prepend($message);
  }
}
